/* import __COLOCATED_TEMPLATE__ from './service-select-therapyfinder-embed.hbs'; */
import { classNames } from '@ember-decorators/component';
import RequestServiceSelect from './service-select';
import styles from './service-select-therapyfinder-embed.module.scss';

@classNames('service-select text-left justify-content-between', styles.component)
export default class RequestServiceSelectTherapyfinderEmbed extends RequestServiceSelect {
  styles = styles;
}
